export default __webpack_public_path__ + "static/media/witten1.5ac601b9.png";